// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"44":"a61928ec","198":"60d38d14","670":"15181b2b","738":"47fadc0b","941":"9608c139","947":"e4c81229","954":"a35cdeac"}[chunkId] + ".css";
};